/**
 * Higher-order component that wraps frame nodes with a right-click
 * context menu (Copy, Move to project, optional Details, Hide, Delete).
 *
 * Applied by the shared frame chrome (withFrameChrome) so individual frame
 * components don't need modification.
 */

import type { ComponentType } from "react";
import type { FrameProps } from "@/components/shapes/shared/frame-props";
import { FrameContextMenu } from "./frame-context-menu";

export function withContextMenu<P extends FrameProps>(
  FrameComponent: ComponentType<P>,
): ComponentType<P> {
  function FrameWithContextMenu(props: P) {
    return (
      <FrameContextMenu frameId={props.id}>
        <FrameComponent {...props} />
      </FrameContextMenu>
    );
  }

  FrameWithContextMenu.displayName = `withContextMenu(${
    FrameComponent.displayName || FrameComponent.name || "Component"
  })`;

  return FrameWithContextMenu;
}
